import { render, staticRenderFns } from "./PdfUploadComponent.vue?vue&type=template&id=87dc911a&scoped=true&"
import script from "./PdfUploadComponent.vue?vue&type=script&lang=js&"
export * from "./PdfUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./PdfUploadComponent.vue?vue&type=style&index=0&id=87dc911a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc911a",
  null
  
)

export default component.exports